module.exports = {
      id: "icon-whatsapp-usage",
      viewBox: "0 0 25.91 25.969",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#icon-whatsapp",
      toString: function () {
        return this.url;
      }
    }